/* global process */
import { API_PATH } from '../constants.js';

const deviceUUID = globalThis.device_uuid;
const HEARTBEAT_INTERVAL_MS = 5 * 1000 * 60; // 5 minutes

if (deviceUUID) {
  const production = process.env.NODE_ENV === 'production';
  const port = production ? 3000 : 3001;
  const url = `http://localhost:${port}/system_metrics`;
  const sendHeartbeat = () => {
    fetch(`${API_PATH}/hardware_devices/${deviceUUID}/heartbeat`, { method: 'POST' }).catch(error => {
      console.error('Failed to send heartbeat:', error);
    });
  };

  const recordSystemStats = () => {
    fetch(url, { method: 'GET' })
      .then(response => {
        if (!response.ok) {
          console.deviceLogError(`Failed to record system stats: ${response.statusText} (status: ${response.status})`);
        }
        response.json().then(data => {
          console.deviceLogDebug(data.human_string);
        });
      })
      .catch(_error => {
        // ignore: this means that the local service isn't running
      });
  };

  setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
  setInterval(recordSystemStats, HEARTBEAT_INTERVAL_MS);

  recordSystemStats();
  sendHeartbeat();
}
